import { EVENT_KEYS } from 'presentation/events';
import { loaderService } from 'presentation/common/services/loader.service';
import {
    getEntries,
    createEntry,
} from 'core/services/tasks.service';

const updateEntries = (selectedList) => {
    return async (dispatch, getState) => {
        let { login } = getState();
        let data = await loaderService({ loaderKey : EVENT_KEYS.LOAD_ENTRIES }, getEntries, login.user.id, selectedList.id);
        let entries = data.entry ? data.entry.entries : null;

        if (entries === null) {
            // No record exists yet — create an empty one
            await loaderService({ loaderKey : EVENT_KEYS.LOAD_ENTRIES }, createEntry, login.user.id, selectedList.id, []);
            entries = [];
        }

        dispatch({
            type : EVENT_KEYS.SET_ENTRY_ADS,
            payload : entries
        });

        dispatch({
            type : EVENT_KEYS.SET_ENTRIES,
            payload : { entries }
        });
    }
};

export const updateTasks = (selectedList) => {
    return async (dispatch) => {
        await dispatch(updateEntries(selectedList));
    }
};

export const mediateGetTasksRequester = (requestTasksSignal, dispatch) => {
    return ((signal) => {
        const handleSignal = async (payload) => {
            await dispatch(updateTasks(payload));
        };

        signal.add(handleSignal);

        return {
            destroy() {
                signal.remove(handleSignal);
            }
        };
    })(requestTasksSignal);
};
